// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGFullscreenIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGFullscreenIcon extends PureComponent<
  ISVGFullscreenIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <g id="Layer_1">
          <g>
            <polygon
              fill="none"
              points="12.755,31.923 13.838,33.006 13.838,30.721 13.838,30.221 13.398,29.721 12.755,29.077 
			12.755,29.721 12.755,30.721 		"
            />
            <polygon
              fill="none"
              points="33.663,22.668 33.663,22.106 33.224,21.668 32.58,21.668 32.58,22.668 		"
            />
            <polygon
              fill="none"
              points="21.737,32.587 21.737,33.273 22.135,33.671 22.737,33.671 22.737,32.587 		"
            />
            <path
              fill="none"
              d="M31.58,11.763V2.921v-1V0.837H20.654v2.95h1.083h1h2.925l0.002-0.002l0.002,0.002h0.021v0.021v0.747
			l-0.224,0.226c-0.042,0.027-0.078,0.069-0.118,0.1c-0.256,0.198-0.493,0.45-0.737,0.728c-0.08,0.09-0.161,0.174-0.24,0.262
			c-0.074,0.081-0.146,0.166-0.221,0.241l-0.759,0.759l-5.436,5.436c-0.149,0.149-0.312,0.292-0.476,0.437
			c-0.216,0.19-0.41,0.376-0.58,0.57c-0.068,0.077-0.143,0.151-0.197,0.233l-0.587,0.194C16,13.7,15.876,13.621,15.749,13.535
			c0.099,0.107,0.207,0.228,0.327,0.361c-0.12-0.134-0.229-0.254-0.327-0.361c-0.481-0.329-1.065-0.952-1.756-1.722
			c-0.085-0.095-0.162-0.18-0.237-0.263L8.805,6.657V6.632L6.722,4.573V3.864V3.759l5.033,0.028V2.921v-1V0.837H0.83v10.925h1.083h1
			h0.866V6.03l9.865,9.78l0.42,0.416l-0.735,0.699c-0.356,0.431-0.886,0.929-1.529,1.504c-0.24,0.215-0.451,0.404-0.586,0.539
			l-4.353,4.405l-1,1.012l-1.296,1.312H3.856H3.779v-0.5v-2.45v-1v-1.083H0.83v10.925h1.083h1h8.842v-0.866v-1v-1.083h-0.176H10.17
			H6.022l9.975-10.062l0.3,0.108c0.652,0.235,1.38,1.075,2.023,1.815c0.151,0.175,0.287,0.328,0.412,0.464
			c0.555,0.351,1.142,1.009,1.671,1.62c0.1,0.116,0.195,0.225,0.284,0.326l4.845,4.788v0.025v0.839h-0.574h-4.304v3.026h1.083h1
			h8.842v-8.919v-1v-1.083h-2.324H28.63v0.788v3.633v1.39l-7.873-7.806l-0.105-0.085l0.005-0.014l-2.088-2.07L18.5,16.225
			c0.194-0.537,1.132-1.353,2.107-2.226c0.241-0.216,0.452-0.405,0.588-0.541l6.649-6.729h0.709l0.077,0.5v2.896v1.423v0.214h1.083
			h1H31.58z"
            />
            <polygon
              fill="none"
              points="29.713,12.763 29.713,13.414 30.213,13.846 30.41,13.846 30.713,13.846 30.713,12.763 		"
            />
            <polygon
              fill="none"
              points="22.737,4.787 21.737,4.787 21.737,5.398 22.442,6.093 22.974,5.871 22.737,5.871 		"
            />
            <polygon
              fill="none"
              points="13.838,2.921 13.838,2.421 13.403,1.921 12.755,1.921 12.755,2.921 		"
            />
            <polygon
              fill="none"
              points="32.58,1.921 32.58,2.921 33.663,2.921 33.663,2.342 33.241,1.921 		"
            />
            <polygon
              fill="none"
              points="12.025,32.587 2.913,32.587 1.913,32.587 1.24,32.587 1.913,33.261 2.323,33.671 2.913,33.671 
			13.088,33.671 12.015,32.597 		"
            />
            <polygon
              fill="none"
              points="4.779,24.057 5.862,22.96 5.862,22.746 5.862,22.153 5.455,21.746 4.779,21.069 4.779,21.746 
			4.779,22.746 		"
            />
            <polygon
              fill="none"
              points="2.913,12.763 1.913,12.763 1.913,13.401 2.385,13.874 5.183,13.846 2.913,13.846 		"
            />
            <polygon
              fill="none"
              points="22.737,32.587 22.737,33.671 32.956,33.671 31.873,32.587 		"
            />
            <polygon
              fill="none"
              points="32.58,31.88 33.663,32.964 33.663,22.668 32.58,22.668 		"
            />
            <path
              fill="none"
              d="M23.857,4.949C23.905,4.895,23.952,4.841,24,4.787h-1.263v1.083h0.236l0.466-0.466
			C23.583,5.262,23.719,5.106,23.857,4.949z"
            />
            <polygon
              fill="none"
              points="12.755,4.055 13.838,5.138 13.838,2.921 12.755,2.921 		"
            />
            <path
              fill="none"
              d="M16.217,19.774l-7.795,7.863h2.74l6.414-6.47c-0.004-0.004-0.007-0.008-0.011-0.013
			C17.176,20.708,16.627,20.076,16.217,19.774z"
            />
            <polygon
              fill="none"
              points="8.361,4.787 9.457,5.871 13.156,5.871 12.073,4.787 		"
            />
            <polygon
              fill="none"
              points="4.779,12.028 4.779,12.028 5.862,13.111 5.862,9.503 4.779,8.429 		"
            />
            <polygon
              fill="none"
              points="2.913,12.763 2.913,13.846 5.183,13.846 4.1,12.763 		"
            />
            <polygon
              fill="none"
              points="32.58,1.259 32.58,1.921 33.241,1.921 		"
            />
            <polygon
              fill="none"
              points="30.713,12.763 30.713,13.846 32.953,13.846 31.87,12.763 		"
            />
            <polygon
              fill="none"
              points="32.58,12.059 33.663,13.142 33.663,2.921 32.58,2.921 		"
            />
            <polygon
              fill="none"
              points="29.062,12.763 29.713,13.414 29.713,12.763 		"
            />
            <polygon
              fill="none"
              points="32.58,21.023 32.58,21.668 33.224,21.668 		"
            />
            <path
              fill="none"
              d="M21.904,14.164c-0.147,0.147-0.373,0.349-0.63,0.58c-0.403,0.361-1.16,1.039-1.498,1.466l1.387,1.375
			c0.356-0.431,0.886-0.928,1.527-1.502c0.241-0.216,0.452-0.405,0.588-0.541l4.352-4.404V8.369L21.904,14.164z"
            />
            <polygon
              fill="none"
              points="12.755,1.272 12.755,1.921 13.403,1.921 		"
            />
            <polygon
              fill="none"
              points="1.274,12.763 1.913,13.401 1.913,12.763 		"
            />
            <polygon
              fill="none"
              points="21.127,4.787 21.737,5.398 21.737,4.787 		"
            />
            <polygon
              fill="none"
              points="21.052,32.587 21.737,33.273 21.737,32.587 		"
            />
            <polygon
              fill="#ffffff"
              points="0.54,12.028 1.274,12.763 1.913,12.763 1.913,11.763 0.83,11.763 0.83,0.837 11.755,0.837 
			11.755,1.921 12.755,1.921 12.755,1.272 12.036,0.554 12.743,-0.153 12.755,-0.142 12.755,-0.163 -0.17,-0.163 -0.17,12.763 
			-0.14,12.763 -0.167,12.735 		"
            />
            <polygon
              fill="#ffffff"
              points="12.025,32.587 12.722,31.89 12.755,31.923 12.755,30.721 11.755,30.721 11.755,31.587 
			2.913,31.587 2.913,32.587 		"
            />
            <path
              fill="#ffffff"
              d="M16.82,13.229c0.021,0.024,0.053,0.058,0.076,0.084c0.17-0.193,0.364-0.38,0.58-0.57
			c0.164-0.144,0.327-0.288,0.476-0.437l5.436-5.436h-1.414L17.245,11.6c-0.134,0.134-0.281,0.262-0.429,0.392
			c-0.206,0.182-0.414,0.37-0.607,0.577l0.029,0.029C16.386,12.744,16.588,12.97,16.82,13.229z"
            />
            <polygon
              fill="#ffffff"
              points="31.873,32.587 31.726,32.441 32.433,31.734 32.58,31.88 32.58,22.668 31.58,22.668 31.58,31.587 
			22.737,31.587 22.737,32.587 		"
            />
            <polygon
              fill="#ffffff"
              points="31.58,11.763 30.713,11.763 30.713,12.763 31.87,12.763 31.842,12.735 32.549,12.028 
			32.58,12.059 32.58,2.921 31.58,2.921 		"
            />
            <path
              fill="#ffffff"
              d="M16.297,18.685l-0.3-0.108L6.022,28.638h4.148l0.991-1h-2.74l7.795-7.863
			c0.411,0.301,0.959,0.934,1.348,1.381c0.004,0.004,0.007,0.008,0.011,0.013l0.504-0.508l0.3,0.108
			c0.114,0.041,0.233,0.121,0.352,0.196c-0.125-0.136-0.26-0.289-0.412-0.464C17.677,19.759,16.949,18.92,16.297,18.685z"
            />
            <path
              fill="#ffffff"
              d="M28.553,6.729h-0.709l-6.649,6.729c-0.136,0.135-0.347,0.324-0.588,0.541
			c-0.975,0.873-1.913,1.689-2.107,2.226l0.069,0.195l2.088,2.07l0.104-0.287c0.066-0.184,0.218-0.395,0.403-0.619l-1.387-1.375
			c0.338-0.427,1.095-1.104,1.498-1.466c0.257-0.231,0.483-0.433,0.63-0.58l5.726-5.794v2.769l1-1.012V7.229L28.553,6.729z"
            />
            <polygon
              fill="#ffffff"
              points="21.127,4.787 21.737,4.787 21.737,3.787 20.654,3.787 20.654,0.837 31.58,0.837 31.58,1.921 
			32.58,1.921 32.58,1.259 31.842,0.521 32.525,-0.163 19.654,-0.163 19.654,4.71 20.352,4.012 		"
            />
            <path
              fill="#ffffff"
              d="M14.476,10.855c-0.121-0.133-0.232-0.254-0.32-0.341l-3.687-3.644h-0.025L14.476,10.855z"
            />
            <path
              fill="#ffffff"
              d="M20.687,22.909c0.101,0.114,0.195,0.217,0.277,0.299l4.568,4.514v-0.025L20.687,22.909z"
            />
            <polygon
              fill="#ffffff"
              points="29.255,20.584 31.58,20.584 31.58,21.668 32.58,21.668 32.58,21.023 31.832,20.275 32.522,19.584 
			27.63,19.584 27.63,20.353 28.327,19.656 		"
            />
            <polygon
              fill="#ffffff"
              points="32.58,-0.163 32.572,-0.163 32.58,-0.155 		"
            />
            <polygon
              fill="#ffffff"
              points="28.63,25.005 28.63,21.373 27.63,20.373 27.63,23.996 21.868,18.283 21.859,18.293 		"
            />
            <polygon
              fill="#ffffff"
              points="21.052,32.587 21.737,32.587 21.737,31.587 20.654,31.587 20.654,28.561 24.958,28.561 
			23.947,27.561 19.654,27.561 19.654,32.587 19.658,32.587 20.355,31.89 		"
            />
            <path
              fill="#ffffff"
              d="M18.3,21.858l-0.049,0.05l1.713,1.692c-0.1-0.111-0.205-0.233-0.316-0.361
			C19.259,22.792,18.71,22.159,18.3,21.858z"
            />
            <polygon
              fill="#ffffff"
              points="25.688,3.787 25.666,3.787 25.688,3.809 		"
            />
            <polygon
              fill="#ffffff"
              points="27.63,12.763 27.648,12.763 27.63,12.745 		"
            />
            <polygon
              fill="#ffffff"
              points="32.58,19.584 32.555,19.584 32.58,19.609 		"
            />
            <polygon
              fill="#ffffff"
              points="11.755,28.638 11.755,29.721 12.755,29.721 12.755,29.077 12.015,28.337 12.715,27.638 
			12.57,27.638 11.579,28.638 		"
            />
            <polygon
              fill="#ffffff"
              points="19.654,4.787 19.713,4.787 19.654,4.729 		"
            />
            <polygon
              fill="#ffffff"
              points="12.755,27.638 12.729,27.638 12.755,27.663 		"
            />
            <polygon
              fill="#ffffff"
              points="29.062,12.763 29.713,12.763 29.713,11.763 28.63,11.763 28.63,11.549 27.63,12.561 27.63,12.725 
			28.327,12.028 		"
            />
            <path
              fill="#ffffff"
              d="M25.346,4.881l-0.389-0.389l0.705-0.705h-2.925v1H24c-0.048,0.054-0.095,0.108-0.143,0.162
			c-0.138,0.157-0.275,0.313-0.417,0.456l-0.466,0.466h1.395c0.08-0.088,0.161-0.171,0.24-0.262
			C24.853,5.331,25.089,5.079,25.346,4.881z"
            />
            <path
              fill="#ffffff"
              d="M11.214,18.966c0.135-0.135,0.346-0.323,0.586-0.539c0.643-0.575,1.173-1.073,1.529-1.504l-0.705-0.699
			c-0.342,0.428-1.09,1.099-1.491,1.458c-0.257,0.23-0.481,0.432-0.628,0.578l-3.643,3.687v1.423L11.214,18.966z"
            />
            <polygon
              fill="#ffffff"
              points="11.755,3.787 6.722,3.759 6.722,3.864 7.222,3.787 		"
            />
            <polygon
              fill="#ffffff"
              points="12.073,4.787 11.87,4.583 12.577,3.876 12.755,4.055 12.755,2.921 11.755,2.921 11.755,3.787 
			7.222,3.787 6.722,3.864 6.722,4.573 8.805,6.632 8.805,5.948 9.305,5.871 9.457,5.871 8.361,4.787 		"
            />
            <polygon
              fill="#ffffff"
              points="3.779,6.03 3.779,11.763 2.913,11.763 2.913,12.763 4.1,12.763 4.072,12.735 4.779,12.028 
			4.779,8.429 5.862,9.503 5.862,8.113 13.644,15.81 		"
            />
            <polygon
              fill="#ffffff"
              points="1.24,32.587 1.913,32.587 1.913,31.587 0.83,31.587 0.83,20.662 3.779,20.662 3.779,21.746 
			4.779,21.746 4.779,21.069 4.072,20.363 4.773,19.662 -0.17,19.662 -0.17,32.587 -0.155,32.587 0.542,31.89 		"
            />
            <polygon
              fill="#ffffff"
              points="3.779,25.695 3.856,25.695 3.779,25.195 		"
            />
            <polygon
              fill="#ffffff"
              points="4.779,22.746 3.779,22.746 3.779,25.195 3.856,25.695 4.565,25.695 5.862,24.383 5.862,22.96 
			4.779,24.057 		"
            />
            <path
              fill="#ffffff"
              d="M15.749,13.535c-0.08-0.087-0.154-0.167-0.215-0.228l-1.778-1.757c0.075,0.083,0.152,0.168,0.237,0.263
			C14.683,12.583,15.267,13.206,15.749,13.535z"
            />
            <polygon
              fill="#ffffff"
              points="20.757,18.589 20.657,18.49 20.652,18.504 		"
            />
            <path
              fill="#ffffff"
              d="M18.731,20.964c0.051,0.055,0.105,0.116,0.15,0.161l1.806,1.784c-0.089-0.101-0.184-0.21-0.284-0.326
			C19.873,21.973,19.287,21.315,18.731,20.964z"
            />
            <path
              fill="#ffffff"
              d="M13.755,11.549c-0.116-0.128-0.222-0.244-0.305-0.326L8.805,6.632v0.025L13.755,11.549z"
            />
            <path
              fill="#ffffff"
              d="M23.278,15.542c-0.136,0.135-0.347,0.324-0.588,0.541c-0.641,0.574-1.171,1.071-1.527,1.502l0.705,0.699
			c0.341-0.427,1.089-1.097,1.489-1.456c0.257-0.231,0.483-0.433,0.63-0.58l3.643-3.687v-1.423L23.278,15.542z"
            />
            <polygon
              fill="#ffffff"
              points="14.119,2.637 13.403,1.921 13.838,2.421 13.838,2.921 13.838,5.138 14.66,5.96 13.953,6.667 
			13.156,5.871 9.457,5.871 10.469,6.871 14.838,6.871 14.838,1.921 14.817,1.921 14.826,1.93 		"
            />
            <polygon
              fill="#ffffff"
              points="5.183,13.846 2.385,13.874 2.623,14.111 1.916,14.818 1.913,14.815 1.913,14.846 6.862,14.846 
			6.862,14.112 6.155,14.818 		"
            />
            <path
              fill="#ffffff"
              d="M16.165,12.611c0.014-0.016,0.031-0.027,0.045-0.042l-1.734-1.714c0.083,0.091,0.167,0.185,0.262,0.29
			C15.088,11.536,15.737,12.261,16.165,12.611z"
            />
            <polygon
              fill="#ffffff"
              points="22.598,6.246 22.974,5.871 22.442,6.093 		"
            />
            <polygon
              fill="#ffffff"
              points="21.737,6.793 21.737,6.871 21.974,6.871 22.597,6.248 		"
            />
            <polygon
              fill="#ffffff"
              points="5.862,9.503 5.862,13.111 6.862,14.111 6.862,10.513 12.624,16.225 12.633,16.215 		"
            />
            <polygon
              fill="#ffffff"
              points="5.862,22.153 5.862,22.746 5.862,22.96 6.862,21.948 6.862,21.746 6.856,21.746 6.155,22.446 		
			"
            />
            <path
              fill="#ffffff"
              d="M17.576,21.168l-6.414,6.47h1.408l5.681-5.73l-0.074-0.074C18.009,21.667,17.802,21.43,17.576,21.168z"
            />
            <polygon
              fill="#ffffff"
              points="2.913,33.671 2.323,33.671 2.625,33.974 1.928,34.671 14.088,34.671 13.088,33.671 		"
            />
            <polygon
              fill="#ffffff"
              points="13.398,29.721 13.838,30.221 13.838,30.721 13.838,33.006 14.805,33.974 14.108,34.671 
			14.838,34.671 14.838,29.721 14.798,29.721 14.098,30.421 		"
            />
            <polygon
              fill="#ffffff"
              points="33.663,22.106 33.663,22.668 33.663,32.964 34.516,33.817 33.809,34.524 32.956,33.671 
			22.737,33.671 22.135,33.671 22.438,33.974 21.741,34.671 34.663,34.671 34.663,21.668 34.605,21.668 33.915,22.358 		"
            />
            <path
              fill="#ffffff"
              d="M19.964,23.6c0.107,0.121,0.207,0.229,0.295,0.317l3.688,3.644h0.025L19.964,23.6z"
            />
            <polygon
              fill="#ffffff"
              points="34.663,14.846 34.663,1.921 34.608,1.921 33.925,2.604 33.663,2.342 33.663,2.921 33.663,13.142 
			34.632,14.111 33.925,14.818 32.953,13.846 30.713,13.846 30.41,13.846 30.213,13.846 29.713,13.414 30.41,14.111 29.713,14.809 
			29.713,14.846 		"
            />
            <polygon
              fill="#ffffff"
              points="28.63,10.126 27.63,11.138 27.63,12.561 28.63,11.549 		"
            />
            <rect x="31.58" y="21.668" fill="#ffffff" width="1" height="1" />
            <rect x="1.913" y="31.587" fill="#ffffff" width="1" height="1" />
            <rect x="11.755" y="29.721" fill="#ffffff" width="1" height="1" />
            <polygon
              fill="#ffffff"
              points="10.17,28.638 11.579,28.638 12.57,27.638 11.162,27.638 		"
            />
            <rect x="31.58" y="1.921" fill="#ffffff" width="1" height="1" />
            <polygon
              fill="#ffffff"
              points="13.835,16.018 5.862,8.113 5.862,9.503 12.633,16.215 12.624,16.225 13.329,16.924 		"
            />
            <path
              fill="#ffffff"
              d="M13.644,15.81l0.197,0.195l-0.005,0.014l-0.104,0.287c-0.066,0.184-0.218,0.395-0.403,0.619l0.735-0.699
			L13.644,15.81z"
            />
            <polygon
              fill="#ffffff"
              points="13.644,15.81 5.862,8.113 13.835,16.018 13.84,16.004 		"
            />
            <path
              fill="#ffffff"
              d="M13.835,16.018l-0.506,0.906c0.185-0.224,0.336-0.436,0.403-0.619L13.835,16.018z"
            />
            <rect x="3.779" y="21.746" fill="#ffffff" width="1" height="1" />
            <path
              fill="#ffffff"
              d="M20.76,18.204l-0.104,0.287l0.1,0.099l7.873,6.416l-6.771-6.712c0.002-0.003,0.006-0.007,0.009-0.01
			l-0.705-0.699C20.979,17.809,20.827,18.02,20.76,18.204z"
            />
            <polygon
              fill="#ffffff"
              points="28.63,25.005 20.757,18.589 28.63,26.395 		"
            />
            <path
              fill="#ffffff"
              d="M25.532,27.722l-4.568-4.514c-0.082-0.082-0.176-0.185-0.277-0.299l-1.806-1.784
			c-0.045-0.045-0.099-0.106-0.15-0.161c-0.118-0.075-0.237-0.155-0.352-0.196l-0.3-0.108l-0.504,0.508
			c0.227,0.262,0.434,0.499,0.601,0.666l0.074,0.074l0.049-0.05c0.411,0.301,0.959,0.934,1.348,1.381
			c0.111,0.128,0.217,0.25,0.316,0.361l4.008,3.961h-0.025l1.012,1L25.532,27.722z"
            />
            <polygon
              fill="#ffffff"
              points="25.532,27.722 24.958,28.561 25.532,28.561 		"
            />
            <rect x="21.737" y="3.787" fill="#ffffff" width="1" height="1" />
            <rect x="11.755" y="1.921" fill="#ffffff" width="1" height="1" />
            <polygon
              fill="#ffffff"
              points="5.862,24.383 6.862,23.371 6.862,21.948 5.862,22.96 		"
            />
            <polygon
              fill="#ffffff"
              points="24.368,5.871 22.974,5.871 22.598,6.246 22.598,6.247 22.597,6.248 21.974,6.871 23.388,6.871 		
			"
            />
            <path
              fill="#ffffff"
              d="M24.368,5.871l-0.98,1l0.759-0.759C24.222,6.036,24.294,5.951,24.368,5.871z"
            />
            <rect x="21.737" y="31.587" fill="#ffffff" width="1" height="1" />
            <rect x="29.713" y="11.763" fill="#ffffff" width="1" height="1" />
            <path
              fill="#ffffff"
              d="M9.305,5.871l-0.5,0.077v0.684l4.646,4.591c0.083,0.083,0.189,0.198,0.305,0.326l1.778,1.757
			c0.061,0.061,0.135,0.141,0.215,0.228l0.364,0.206l0.587-0.194c0.054-0.082,0.129-0.156,0.197-0.233
			c-0.023-0.026-0.055-0.061-0.076-0.084c-0.232-0.258-0.435-0.484-0.582-0.631l-0.029-0.029c-0.014,0.015-0.031,0.027-0.045,0.042
			c-0.427-0.351-1.077-1.075-1.427-1.466c-0.094-0.105-0.179-0.199-0.262-0.29l-4.032-3.984h0.025l-1.012-1H9.305z"
            />
            <path
              fill="#ffffff"
              d="M15.749,13.535C15.876,13.621,16,13.7,16.112,13.74L15.749,13.535z"
            />
            <rect x="1.913" y="11.763" fill="#ffffff" width="1" height="1" />
            <polygon
              fill="#ffffff"
              points="1.274,12.763 -0.14,12.763 1.913,14.815 1.913,13.401 		"
            />
            <polygon
              fill="#ffffff"
              points="0.54,12.028 -0.167,12.735 -0.14,12.763 1.274,12.763 		"
            />
            <polygon
              fill="#ffffff"
              points="2.623,14.111 2.385,13.874 1.913,13.401 1.913,14.815 1.916,14.818 		"
            />
            <polygon
              fill="#ffffff"
              points="6.862,14.111 6.862,14.111 6.862,14.112 		"
            />
            <polygon
              fill="#ffffff"
              points="4.779,12.028 4.779,12.763 4.1,12.763 5.183,13.846 5.862,13.846 5.862,13.111 4.779,12.028 		"
            />
            <polygon
              fill="#ffffff"
              points="4.779,12.028 4.072,12.735 4.1,12.763 4.779,12.763 		"
            />
            <polygon
              fill="#ffffff"
              points="5.862,13.846 5.183,13.846 6.155,14.818 6.862,14.112 6.862,14.111 5.862,13.111 		"
            />
            <polygon
              fill="#ffffff"
              points="12.755,4.787 12.073,4.787 13.156,5.871 13.838,5.871 13.838,5.138 12.755,4.055 		"
            />
            <polygon
              fill="#ffffff"
              points="11.87,4.583 12.073,4.787 12.755,4.787 12.755,4.055 12.577,3.876 		"
            />
            <polygon
              fill="#ffffff"
              points="13.156,5.871 13.953,6.667 14.66,5.96 13.838,5.138 13.838,5.871 		"
            />
            <polygon
              fill="#ffffff"
              points="19.645,4.719 19.654,4.729 19.654,4.71 		"
            />
            <polygon
              fill="#ffffff"
              points="21.127,4.787 19.713,4.787 21.728,6.803 21.737,6.793 21.737,5.398 		"
            />
            <polygon
              fill="#ffffff"
              points="20.352,4.012 19.654,4.71 19.654,4.729 19.713,4.787 21.127,4.787 		"
            />
            <polygon
              fill="#ffffff"
              points="22.435,6.096 22.442,6.093 21.737,5.398 		"
            />
            <polygon
              fill="#ffffff"
              points="21.737,5.398 21.737,6.793 22.435,6.096 		"
            />
            <polygon
              fill="#ffffff"
              points="22.598,6.246 22.442,6.093 22.435,6.096 21.737,6.793 22.597,6.248 		"
            />
            <polygon
              fill="#ffffff"
              points="22.598,6.247 22.598,6.246 22.597,6.248 		"
            />
            <polygon
              fill="#ffffff"
              points="25.664,3.785 25.662,3.787 25.666,3.787 		"
            />
            <path
              fill="#ffffff"
              d="M25.346,4.881c0.04-0.031,0.077-0.072,0.118-0.1l0.224-0.226V3.809l-0.021-0.021h-0.004l-0.705,0.705
			L25.346,4.881z"
            />
            <polygon
              fill="#ffffff"
              points="33.241,1.921 34.608,1.921 34.632,1.897 32.58,-0.155 32.58,1.259 		"
            />
            <polygon
              fill="#ffffff"
              points="32.549,-0.186 32.525,-0.163 32.572,-0.163 		"
            />
            <polygon
              fill="#ffffff"
              points="32.58,1.259 32.58,-0.155 32.572,-0.163 32.525,-0.163 31.842,0.521 		"
            />
            <polygon
              fill="#ffffff"
              points="33.663,2.342 33.925,2.604 34.608,1.921 33.241,1.921 		"
            />
            <polygon
              fill="#ffffff"
              points="32.58,12.763 31.87,12.763 32.953,13.846 33.663,13.846 33.663,13.142 32.58,12.059 		"
            />
            <polygon
              fill="#ffffff"
              points="31.842,12.735 31.87,12.763 32.58,12.763 32.58,12.059 32.549,12.028 		"
            />
            <polygon
              fill="#ffffff"
              points="32.953,13.846 33.925,14.818 34.632,14.111 33.663,13.142 33.663,13.846 		"
            />
            <polygon
              fill="#ffffff"
              points="27.62,12.735 27.63,12.745 27.63,12.725 		"
            />
            <polygon
              fill="#ffffff"
              points="29.062,12.763 27.648,12.763 29.703,14.818 29.713,14.809 29.713,13.414 		"
            />
            <polygon
              fill="#ffffff"
              points="28.327,12.028 27.63,12.725 27.63,12.745 27.648,12.763 29.062,12.763 		"
            />
            <polygon
              fill="#ffffff"
              points="29.713,13.414 29.713,14.809 30.41,14.111 		"
            />
            <polygon
              fill="#ffffff"
              points="27.62,20.363 27.63,20.373 27.63,20.353 		"
            />
            <polygon
              fill="#ffffff"
              points="28.63,20.584 29.255,20.584 28.327,19.656 27.63,20.353 27.63,20.373 28.63,21.373 		"
            />
            <polygon
              fill="#ffffff"
              points="33.224,21.668 34.605,21.668 34.622,21.651 32.58,19.609 32.58,21.023 		"
            />
            <polygon
              fill="#ffffff"
              points="32.539,19.568 32.522,19.584 32.555,19.584 		"
            />
            <polygon
              fill="#ffffff"
              points="32.58,21.023 32.58,19.609 32.555,19.584 32.522,19.584 31.832,20.275 		"
            />
            <polygon
              fill="#ffffff"
              points="33.663,22.106 33.915,22.358 34.605,21.668 33.224,21.668 		"
            />
            <polygon
              fill="#ffffff"
              points="32.58,32.587 31.873,32.587 32.956,33.671 33.663,33.671 33.663,32.964 32.58,31.88 		"
            />
            <polygon
              fill="#ffffff"
              points="31.726,32.441 31.873,32.587 32.58,32.587 32.58,31.88 32.433,31.734 		"
            />
            <polygon
              fill="#ffffff"
              points="32.956,33.671 33.809,34.524 34.516,33.817 33.663,32.964 33.663,33.671 		"
            />
            <polygon
              fill="#ffffff"
              points="21.737,33.273 21.052,32.587 19.658,32.587 19.648,32.597 21.731,34.681 21.741,34.671 
			21.737,34.671 		"
            />
            <polygon
              fill="#ffffff"
              points="20.355,31.89 19.658,32.587 21.052,32.587 		"
            />
            <polygon
              fill="#ffffff"
              points="22.135,33.671 21.737,33.273 21.737,34.671 21.741,34.671 22.438,33.974 		"
            />
            <polygon
              fill="#ffffff"
              points="14.098,34.681 14.108,34.671 14.088,34.671 		"
            />
            <polygon
              fill="#ffffff"
              points="12.755,32.587 12.025,32.587 12.015,32.597 13.088,33.671 13.838,33.671 13.838,33.006 
			12.755,31.923 		"
            />
            <polygon
              fill="#ffffff"
              points="12.025,32.587 12.755,32.587 12.755,31.923 12.722,31.89 		"
            />
            <polygon
              fill="#ffffff"
              points="13.838,33.006 13.838,33.671 13.088,33.671 14.088,34.671 14.108,34.671 14.805,33.974 		"
            />
            <polygon
              fill="#ffffff"
              points="1.913,33.261 1.24,32.587 -0.155,32.587 -0.165,32.597 1.918,34.681 1.928,34.671 1.913,34.671 		
			"
            />
            <polygon
              fill="#ffffff"
              points="0.542,31.89 -0.155,32.587 1.24,32.587 		"
            />
            <polygon
              fill="#ffffff"
              points="2.323,33.671 1.913,33.261 1.913,34.671 1.928,34.671 2.625,33.974 		"
            />
            <polygon
              fill="#ffffff"
              points="13.398,29.721 14.798,29.721 14.805,29.714 12.755,27.663 12.755,29.077 		"
            />
            <polygon
              fill="#ffffff"
              points="12.722,27.63 12.715,27.638 12.729,27.638 		"
            />
            <polygon
              fill="#ffffff"
              points="12.755,29.077 12.755,27.663 12.729,27.638 12.715,27.638 12.015,28.337 		"
            />
            <polygon
              fill="#ffffff"
              points="14.098,30.421 14.798,29.721 13.398,29.721 		"
            />
            <polygon
              fill="#ffffff"
              points="4.779,21.069 5.455,21.746 6.856,21.746 6.862,21.739 4.779,19.656 4.773,19.662 4.779,19.662 		
			"
            />
            <polygon
              fill="#ffffff"
              points="4.779,21.069 4.779,19.662 4.773,19.662 4.072,20.363 		"
            />
            <polygon
              fill="#ffffff"
              points="5.862,22.153 6.155,22.446 6.856,21.746 5.455,21.746 		"
            />
            <polygon
              fill="#ffffff"
              points="13.403,1.921 14.817,1.921 12.755,-0.142 12.755,1.272 		"
            />
            <polygon
              fill="#ffffff"
              points="12.036,0.554 12.755,1.272 12.755,-0.142 12.743,-0.153 		"
            />
            <polygon
              fill="#ffffff"
              points="14.119,2.637 14.826,1.93 14.817,1.921 13.403,1.921 		"
            />
          </g>
        </g>
      </svg>
    );
  }
}
